import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const connectwiseRmm = defineConnector({
  identifier: "connectwiseRmm",
  name: "ConnectWise RMM",
  tagLine: "Remote monitoring and management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ subdomain }) =>
    subdomain
      ? `https://openapi\\.service\\.${subdomain.replace(/\./g, "\\.")}/.*`
      : ".*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your ConnectWise RMM instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your ConnectWise RMM instance.",
        },
        {
          kind: "input",
          label: "API Subdomain",
          placeholder: "itsupport247.net",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "The ConnectWise RMM OpenAPI subdomain for your region (e.g. https://openapi.service.itsupport247.net)",
        },
      ],
    },
    {
      title: "Create a ConnectWise RMM app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [ConnectWise Asio developer docs](https://developer.connectwise.com/Products/Asio/Overview) and create a machine-to-machine application for ConnectWise RMM. Copy the client ID and client secret, and note the regional service subdomain for your tenant.",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: (configuration) =>
      `https://openapi.service.${configuration.subdomain}/v1/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://openapi.service.${configuration.subdomain}/`,
  },
  publicEnvVars: ({ subdomain }) => ({
    CONNECTWISE_RMM_URL: subdomain
      ? `https://openapi.service.${subdomain}`
      : "",
  }),
});
